import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    footer: {
        width: '100%',
        marginTop: 'auto',
        marginBottom: 10
    },
}));

export default useStyles;